<template>
    <div class="confirmation">
        <div class="confirmation-checkmark"><img src="../../assets/check_circle-24px.svg" /></div>
        <h3>{{title}}</h3>
        <p>{{message}}</p>
        <ul v-if="hasContactInfo" class="list-unstyled contact-list">
            <li class="email">
                <a :href="emailHref">{{form.contactInfo.email}}</a>
            </li>
            <li class="phone">
                <a :href="phoneHref">{{form.contactInfo.phone}}</a>
            </li>
        </ul>
        <div v-if="address" class="d-inline-block"><a class="btn" :href="directionsHref" target="_blank">Get directions</a></div>
        <div v-if="address" class="d-inline-block reload-link">
            <a href="#" @click.prevent.stop="reload()">Schedule Another Booking</a>
        </div>
        <div v-else class="d-inline-block reload-link no-left-padding">
            <a href="#" @click.prevent.stop="reload()">Schedule Another Booking</a>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import schedulingMixin from '../../mixins/schedulingMixin';

  export default {
    mixins: [schedulingMixin],
    props: {
        address: '',
    },
    methods: {
        reload() {
            location.reload();
            return false;
        }
    },
    computed: {
        ...mapGetters('form', [
          'fields',
          'inline_title',
          'inline_message'
        ]),
        ...mapState('form', { form: 'form' }),
        directionsHref() {
            return 'https://www.google.com/maps/dir/?api=1&destination='+this.address;
        },
        title() {
            return this.inline_title ? this.inline_title : 'Booking Scheduled';
        },
        message() {
            return this.inline_message ? this.inline_message : 'We\'ve sent you an email confirmation. To cancel or adjust this appointment, please contact us.';
        },
        hasContactInfo() {
            return this.form.contactInfo && (this.form.contactInfo.email || this.form.contactInfo.phone);
        },
        emailHref() {
            return 'mailto:' + this.form.contactInfo.email;
        },
        phoneHref() {
            return 'tel:' + this.form.contactInfo.phone;
        }
    }
  };
</script>
<style>
.confirmation .la-check-circle {
    color: rgb(0, 109, 208);
    font-size: 48px;
}
.confirmation .btn {
    border: 1px solid #dedede;
    font-weight: 500;
    padding-top: 12px;
    padding-bottom: 12px;
}
.confirmation .contact-list li {
    display: inline-block;
    padding-right: 15px;
}
.confirmation .contact-list li i {
    color: #aaa;
    padding-right: 5px;
}
.reload-link {
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 15px;
}
.reload-link a {
    color: #696969;
}
.reload-link a:hover {
    color: #696969;
    text-decoration: underline;
}
.contact-list li {
    padding-left: 24px;
}
.contact-list .phone {
    background: transparent url("../../assets/local_phone-24px.svg") no-repeat left center;
}
.contact-list .email {
    background: transparent url("../../assets/email-24px.svg") no-repeat left center;
}
.no-left-padding { padding-left: 0 }
</style>
